"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CacheStoreType_1 = __importDefault(require("../../enums/CacheStoreType"));
var utilities_1 = require("@ikea-aoa/utilities");
/**
 * This class is used for storing and loading availability items from cache.
 */
var StoreAvailabilityCache = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param locale Locale.
     * @param cache Cache store.
     */
    function StoreAvailabilityCache(locale, cache) {
        this.locale = null;
        this.cache = null;
        this.storeAvailabilities = new Map();
        this.locale = locale;
        this.cache = cache || new utilities_1.GlobalCacheStore();
    }
    /**
     * Returns multiple cached availabilities.
     *
     * @param storeId Store ID.
     * @param items Array of items.
     * @returns Availabilities and missing items.
     */
    StoreAvailabilityCache.prototype.getStoreAvailabilities = function (storeId, items) {
        var availabilities = [];
        var missing = [];
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var availability = this.getStoreAvailability(storeId, item);
            if (availability) {
                availabilities.push(this.getStoreAvailability(storeId, item));
            }
            else {
                missing.push(item);
            }
        }
        return { availabilities: availabilities, missing: missing };
    };
    /**
     * Adds multiple availabilities.
     *
     * @param storeId Store ID.
     * @param availabilities Availabilities.
     */
    StoreAvailabilityCache.prototype.addStoreAvailabilities = function (storeId, availabilities) {
        for (var _i = 0, availabilities_1 = availabilities; _i < availabilities_1.length; _i++) {
            var availability = availabilities_1[_i];
            this.addStoreAvailability(storeId, availability);
        }
    };
    /**
     * Removes a availability from cache.
     *
     * @param storeId Store ID.
     * @param availabilities Availabilities.
     */
    StoreAvailabilityCache.prototype.removeStoreAvailabilities = function (storeId, availabilities) {
        for (var _i = 0, availabilities_2 = availabilities; _i < availabilities_2.length; _i++) {
            var availability = availabilities_2[_i];
            this.removeStoreAvailability(storeId, availability);
        }
    };
    /**
     * Removes all store availabilities connected to the instance.
     */
    StoreAvailabilityCache.prototype.clear = function () {
        var _this = this;
        this.storeAvailabilities.forEach(function (_value, cacheKey) {
            _this.cache.getStore(CacheStoreType_1.default.storeAvailability).delete(cacheKey);
        });
        this.storeAvailabilities = new Map();
    };
    /**
     * Returns cached availabilities.
     *
     * @param storeId Store ID.
     * @param item Item.
     * @returns Availability.
     */
    StoreAvailabilityCache.prototype.getStoreAvailability = function (storeId, item) {
        var cached = this.cache
            .getStore(CacheStoreType_1.default.storeAvailability)
            .get(this.getCacheKey(storeId, item));
        return cached || null;
    };
    /**
     * Removes a availability from cache.
     *
     * @param storeId Store ID.
     * @param availability Availability.
     */
    StoreAvailabilityCache.prototype.removeStoreAvailability = function (storeId, availability) {
        var cacheKey = this.getCacheKey(storeId, {
            type: availability.type,
            id: availability.id
        });
        this.storeAvailabilities.delete(cacheKey);
        this.cache.getStore(CacheStoreType_1.default.storeAvailability).delete(cacheKey);
    };
    /**
     * Adds a availability to cache.
     *
     * @param storeId Store ID.
     * @param availability Availability.
     */
    StoreAvailabilityCache.prototype.addStoreAvailability = function (storeId, availability) {
        var cacheKey = this.getCacheKey(storeId, { id: availability.id, type: availability.type });
        this.storeAvailabilities.set(cacheKey, availability);
        this.cache.getStore(CacheStoreType_1.default.storeAvailability).set(cacheKey, availability);
    };
    /**
     * Returns cache key for an item.
     *
     * @param storeId Store ID.
     * @param item Item.
     * @returns Cache key.
     */
    StoreAvailabilityCache.prototype.getCacheKey = function (storeId, item) {
        return this.locale + storeId + item.type.toLowerCase() + item.id;
    };
    return StoreAvailabilityCache;
}());
exports.default = StoreAvailabilityCache;
//# sourceMappingURL=StoreAvailabilityCache.js.map